import { Directive } from '@angular/core';
import { GtmTrackClickDirectiveDef } from '@df/module-gtm/gtm-track-click.directive.def';

@Directive({
    selector: '[gtmTrackClick]',
    standalone: true
})
export class GtmTrackClickDirective extends GtmTrackClickDirectiveDef {}
